import ReactDOM from 'react-dom/client';
import { AppProvider } from "@shopify/polaris";
import enTranslations from '@shopify/polaris/locales/en.json';
import { store, StoreContext } from "./app/stores/store";
// Polaris React is kept only for routes not yet migrated to Polaris web
// components. Remove it (and this stylesheet) once no route imports it.
import "@shopify/polaris/build/esm/styles.css";
import "./styles.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router/Routes";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AppProvider i18n={enTranslations}>
    <StoreContext.Provider value={store}>
      <RouterProvider router={router} />
    </StoreContext.Provider>
  </AppProvider>
);
